import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import HireAndAnalyticsContainer from '~/features/hire-n-analytics'
import en_hire_n_analyze from '../../../public/locales/en/hire-and-analyze.json'
import jp_hire_n_analyze from '../../../public/locales/ja/hire-and-analyze.json'
// import jsonLd from '../../../public/schema.json'

const HireAndAnalyzePage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      /> */}
      <HeadMetaTags
        title={t('meta:ats_hire_and_analyze:meta_title')}
        description={t('meta:ats_hire_and_analyze:meta_description')}
      />
      <HireAndAnalyticsContainer />
    </>
  )
}

export default withTranslateProvider(HireAndAnalyzePage, {
  en: { hire_n_analyze: en_hire_n_analyze },
  ja: { hire_n_analyze: jp_hire_n_analyze }
})
